<template>
  <div class="input-file">
    <label class="input-file__label">
      {{label}}:
    </label>
    <div class="fluke-btn input-file__custom-input">
      <label>
        <input
          class="input-file__custom-input__original"
          type="file"
          ref="input_file"
          :accept="accept"
          @change="onChange"
        />
        <div class="input-file__custom-input__text">
          Selecione um arquivo
        </div>
        <div class="input-file__custom-input__name" v-if="file">
          <div class="input-file__custom-input__name__label">
            {{file.name}} 
          </div>
          <div class="input-file__custom-input__name__size">
            ({{uploadFileSize}})
          </div>
        </div>
      </label>
    </div>
    <div 
      v-if="file && removable" 
      @click.prevent="onRemove"
      class="input-file__remove"
    >
      <i class="material-icons">close</i>
      Remover arquivo selecionado
    </div>
    <div 
      v-if="currentFile"
      class="input-file__current-file"
    >
      <div class="input-file__current-file__label">
        {{label}} atual{{sizeLabel}}:
      </div>
      <a 
        :href="currentFile"
        class="input-file__current-file__link"
        target="_blank"
      >{{currentFile}}</a>
    </div>
  </div>
</template>

<script>
  import fileUtils from '../../../../helpers/file_utils'
  export default {
    props: {
      label: String,
      accept: String,
      currentFile: String,
      file: File,
      removable: {
        type: Boolean,
        default: true
      },
      size: Number
    },
    methods: {
      onChange (e) {
        if (e.target.files.length > 0) {
          this.$emit('change', e)
        }
      },
      onRemove () {
        this.$refs.input_file.value = ''
        this.$emit('remove')
      }
    },
    computed: {
      sizeLabel () {
        if (this.size) {
          const sizeHumanize = fileUtils.bytesToSize(this.size)
          return ` (${sizeHumanize})`
        }
      },
      uploadFileSize () {
        const sizeHumanize = fileUtils.bytesToSize(this.file.size)
        return sizeHumanize
      }
    }
  }
</script>

<style lang="scss">
  .input-file {
    &__label {
      display: block;
      margin: 0 0 5px 0;
    }
    &__custom-input {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      label {
        cursor: pointer;
      }
      &__original {
        cursor: pointer;
        position: absolute;
        opacity: 0;
      }
      &__text {
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
      }
      &__name {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &__label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-grow: 1;
        }
        &__size {
          flex-shrink: 0;
        }
      }
      &:hover {
        font-weight: inherit;
      }
    }
    &__remove {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 10px 0;
    }
    &__current-file {
      margin: 10px 0 0 0;
      &__label {}
      &__link {
        color: inherit;
      }
    }
  }
</style>
